import * as firebase from 'firebase/app';
import 'firebase/firestore';
import { roundNum } from 'utils/numbers';
import { NUTRITIONS, FOOD } from 'utils/constants/collectionNames';
import { USER_NOT_SIGNED_IN_ERROR_MSG } from 'utils/constants/errors';
import {
  GET_NUTRITION_PLANS_SUCCEEDED,
  GET_NUTRITION_PLANS_ERROR,
  GET_CLIENT_NUTRITION_PLANS_SUCCEEDED,
  GET_CLIENT_NUTRITION_PLANS_ERROR,
  GET_NUTRITION_PLAN_SUCCEEDED,
  GET_NUTRITION_PLAN_ERROR,
  ASSIGN_CLIENT_TO_PLANS_SUCCEEDED,
  ASSIGN_CLIENT_TO_PLANS_ERROR,
  ASSIGN_PLAN_TO_CLIENTS_SUCCEEDED,
  ASSIGN_PLAN_TO_CLIENTS_ERROR,
  RENAME_PLAN_SUCCEEDED,
  RENAME_PLAN_ERROR,
  CREATE_PLAN_SUCCEEDED,
  CREATE_PLAN_ERROR,
  DELETE_PLAN_SUCCEEDED,
  DELETE_PLAN_ERROR,
  UNASSIGN_CLIENT_FROM_PLAN_SUCCEEDED,
  UNASSIGN_CLIENT_FROM_PLAN_ERROR,
  CREATE_MEAL_SUCCEEDED,
  CREATE_MEAL_ERROR,
  EDIT_MEAL_SUCCEEDED,
  EDIT_MEAL_ERROR,
  SEARCH_FOOD_SUCCEEDED,
  SEARCH_FOOD_ERROR,
  CREATE_FOOD_SUCCEEDED,
  CREATE_FOOD_ERROR,
  LOADING_FOOD,
  NUTRATION_LOADING_STATE,
  CURRENT_NUTRATION_LOADING_STATE,
  CLIENT_NUTRATION_LOADING_STATE,
  GET_MEASUREMENTS_SUCCEEDED,
  GET_MEASUREMENTS_ERROR,
  LOADING_MEASUREMENTS,
  DELETE_MEAL_SUCCEEDED,
  DELETE_MEAL_ERROR
} from './types';

// fetch trainer's nutrition plans from Firebase
export const getTrainerNutritionPlans = () => async dispatch => {
  try {
    let firestore = firebase.firestore();
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        dispatch({ type: NUTRATION_LOADING_STATE });
        let queryRef = firestore
          .collection(NUTRITIONS)
          .where('trainer_id', '==', user.uid)
          .orderBy('created_at', 'desc');
        return queryRef.onSnapshot(querySnapshot => {
          const plans =
            querySnapshot.docs &&
            querySnapshot.docs.map(doc => {
              return {
                ...doc.data(),
                id: doc.id
              };
            });
          dispatch({
            type: GET_NUTRITION_PLANS_SUCCEEDED,
            payload: { plans }
          });
        });
      } else {
        throw new Error(USER_NOT_SIGNED_IN_ERROR_MSG);
      }
    });
  } catch (err) {
    console.log(err);
    dispatch({
      type: GET_NUTRITION_PLANS_ERROR,
      payload: `error: ${err}`
    });
  }
};

// fetch client's nutrition plans from Firebase
export const getClientNutritionPlans = clientId => async dispatch => {
  try {
    let firestore = firebase.firestore();

    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        dispatch({ type: CLIENT_NUTRATION_LOADING_STATE });
        let queryRef = firestore
          .collection(NUTRITIONS)
          .where('trainer_id', '==', user.uid)
          .where('clients_id', 'array-contains', clientId);
        return queryRef.onSnapshot(querySnapshot => {
          const plans =
            querySnapshot.docs &&
            querySnapshot.docs.map(doc => {
              return {
                ...doc.data(),
                id: doc.id
              };
            });
          dispatch({
            type: GET_CLIENT_NUTRITION_PLANS_SUCCEEDED,
            payload: { plans }
          });
        });
      } else {
        throw new Error(USER_NOT_SIGNED_IN_ERROR_MSG);
      }
    });
  } catch (err) {
    console.log(err);
    dispatch({
      type: GET_CLIENT_NUTRITION_PLANS_ERROR,
      payload: `error: ${err}`
    });
  }
};

// get nutrition plan from Firebase
export const getNutritionPlan = (planId, history) => async dispatch => {
  let firestore = firebase.firestore();
  var docRef = firestore.collection(NUTRITIONS).doc(planId);
  dispatch({ type: CURRENT_NUTRATION_LOADING_STATE });
  docRef
    .get()
    .then(doc => {
      if (doc.exists) {
        dispatch({
          type: GET_NUTRITION_PLAN_SUCCEEDED,
          payload: {
            ...doc.data(),
            id: doc.id
          }
        });
      } else {
        console.log('No such plan!');
        dispatch({
          type: GET_NUTRITION_PLAN_ERROR,
          payload: 'error: No such plan!'
        });
        history.replace('/event-not-found');
      }
    })
    .catch(err => {
      dispatch({
        type: GET_NUTRITION_PLAN_ERROR,
        payload: 'error: No such plan!'
      });
      history.replace('/event-not-found');
    });
};

// assign client to multiple nutrition plans
export const assignClientToPlans = (
  client,
  plansId,
  history
) => async dispatch => {
  let firestore = firebase.firestore();
  var batch = firestore.batch();
  const assignDate = new Date();

  plansId.forEach(planId => {
    let docRef = firestore.collection(NUTRITIONS).doc(planId);
    batch.set(
      docRef,
      {
        clients_id: firebase.firestore.FieldValue.arrayUnion(client.id),
        clients_data: {
          [`${client.id}`]: {
            assigned_at: assignDate,
            photo_url: client.photo || '',
            display_name: `${client.first_name} ${client.last_name}`
          }
        }
      },
      { merge: true }
    );
  });

  batch
    .commit()
    .then(function() {
      dispatch({
        type: ASSIGN_CLIENT_TO_PLANS_SUCCEEDED
      });
      history.push(`/clients/${client.id}?tab=nutrition`);
    })
    .catch(function(error) {
      console.log(error);
      dispatch({
        type: ASSIGN_CLIENT_TO_PLANS_ERROR,
        payload: `error: ${error}`
      });
    });
};

// assign plan to multiple clients
export const assignPlanToClients = (
  planId,
  clients,
  history
) => async dispatch => {
  let firestore = firebase.firestore();
  const assignDate = new Date();

  let docRef = firestore.collection(NUTRITIONS).doc(planId);
  var clientsId = [];
  var clientsData = {};
  clients.forEach(client => {
    clientsId.push(client.id);
    clientsData = {
      ...clientsData,
      [`${client.id}`]: {
        assigned_at: assignDate,
        photo_url: client.photo || '',
        display_name: `${client.first_name} ${client.last_name}`
      }
    };
  });

  return docRef
    .set(
      {
        clients_id: firebase.firestore.FieldValue.arrayUnion(...clientsId),
        clients_data: clientsData
      },
      { merge: true }
    )
    .then(function() {
      dispatch({
        type: ASSIGN_PLAN_TO_CLIENTS_SUCCEEDED
      });
      history.push(`/nutrition/${planId}`);
    })
    .catch(function(error) {
      console.log(error);
      dispatch({
        type: ASSIGN_PLAN_TO_CLIENTS_ERROR,
        payload: `error: ${error}`
      });
    });
};

export const renameNutritionPlan = (
  planId,
  name,
  history
) => async dispatch => {
  let firestore = firebase.firestore();
  var docRef = firestore.collection(NUTRITIONS).doc(planId);

  docRef
    .set({ name: name }, { merge: true })
    .then(function() {
      history.push(`/nutrition/${planId}`);
      dispatch({
        type: RENAME_PLAN_SUCCEEDED
      });
    })
    .catch(function(error) {
      console.log(error);
      dispatch({
        type: RENAME_PLAN_ERROR,
        payload: `error: ${error}`
      });
    });
};

// create plan by name
export const createNutritionPlan = (name, history) => async dispatch => {
  let firestore = firebase.firestore();
  var docRef = firestore.collection(NUTRITIONS);

  firebase.auth().onAuthStateChanged(user => {
    if (user) {
      const newPlan = {
        name: name,
        created_at: new Date(),
        trainer_id: user.uid,
        assigner_name: user.displayName,
        clients_data: {},
        clients_id: [],
        meal_items: [],
        meals_count: 0,
        photo_url: '',
        snacks_count: 0,
        total_calories: 0,
        total_carbs: 0,
        total_fat: 0,
        total_protein: 0
      };

      return docRef
        .add(newPlan)
        .then(function(doc) {
          history.push(`/nutrition/${doc.id}`);
          dispatch({
            type: CREATE_PLAN_SUCCEEDED
          });
        })
        .catch(function(error) {
          console.log(error);
          dispatch({
            type: CREATE_PLAN_ERROR,
            payload: `error: ${error}`
          });
        });
    } else {
      dispatch({
        type: CREATE_PLAN_ERROR,
        payload: `error: ${USER_NOT_SIGNED_IN_ERROR_MSG}`
      });
    }
  });
};

// delete nutrition plan
export const deleteNutritionPlan = planId => async dispatch => {
  let db = firebase.firestore();
  db.collection(NUTRITIONS)
    .doc(planId)
    .delete()
    .then(function() {
      dispatch({ type: DELETE_PLAN_SUCCEEDED });
    })
    .catch(function(error) {
      console.error('Error removing document: ', error);
      dispatch({
        type: DELETE_PLAN_ERROR,
        payload: `error: ${error}`
      });
    });
};

export const unassignClientFromNutritionPlan = (
  clientId,
  planId
) => async dispatch => {
  let firestore = firebase.firestore();
  var docRef = firestore.collection(NUTRITIONS).doc(planId);

  return docRef
    .update({
      clients_id: firebase.firestore.FieldValue.arrayRemove(clientId),
      [`clients_data.${clientId}`]: firebase.firestore.FieldValue.delete()
    })
    .then(() => {
      return docRef.get().then(doc => {
        dispatch({
          type: UNASSIGN_CLIENT_FROM_PLAN_SUCCEEDED,
          payload: { ...doc.data(), id: planId }
        });
      });
    })
    .catch(function(error) {
      console.log(error);
      dispatch({
        type: UNASSIGN_CLIENT_FROM_PLAN_ERROR,
        payload: `error: ${error}`
      });
    });
};

// create meal
export const createMeal = (plan, meal, history) => async dispatch => {
  let firestore = firebase.firestore();
  let docRef = firestore.collection(NUTRITIONS).doc(plan.id);
  const mealObj = {
    created_at: new Date(),
    ...meal
  };

  docRef
    .set(
      {
        meals_count:
          meal.type === 'meal' ? plan.meals_count + 1 : plan.meals_count,
        snacks_count:
          meal.type === 'snack' ? plan.snacks_count + 1 : plan.snacks_count,
        total_calories: roundNum(
          plan.total_calories + meal.ingredients_calories
        ),
        total_carbs: roundNum(plan.total_carbs + meal.ingredients_carbs),
        total_fat: roundNum(plan.total_fat + meal.ingredients_fat),
        total_protein: roundNum(plan.total_protein + meal.ingredients_protein),
        meal_items: firebase.firestore.FieldValue.arrayUnion(mealObj)
      },
      { merge: true }
    )
    .then(function() {
      dispatch({
        type: CREATE_MEAL_SUCCEEDED
      });
      history.push(`/nutrition/${plan.id}`);
    })
    .catch(function(error) {
      console.log(error);
      dispatch({
        type: CREATE_MEAL_ERROR,
        payload: `error: ${error}`
      });
      history.push(`/nutrition/${plan.id}`);
    });
};

// edit meal
export const editMeal = (plan, meal, history) => async dispatch => {
  let firestore = firebase.firestore();
  let docRef = firestore.collection(NUTRITIONS).doc(plan.id);

  var meal_items = [...plan.meal_items];
  const index = meal.index;
  delete meal.index;
  meal_items[index] = meal;

  docRef
    .set(
      {
        total_calories: roundNum(
          plan.total_calories +
            meal.ingredients_calories -
            plan.meal_items[index].ingredients_calories
        ),
        total_carbs: roundNum(
          plan.total_carbs +
            meal.ingredients_carbs -
            plan.meal_items[index].ingredients_carbs
        ),
        total_fat: roundNum(
          plan.total_fat +
            meal.ingredients_fat -
            plan.meal_items[index].ingredients_fat
        ),
        total_protein: roundNum(
          plan.total_protein +
            meal.ingredients_protein -
            plan.meal_items[index].ingredients_protein
        ),
        meal_items: meal_items
      },
      { merge: true }
    )
    .then(function() {
      dispatch({
        type: EDIT_MEAL_SUCCEEDED
      });
      history.push(`/nutrition/${plan.id}`);
    })
    .catch(function(error) {
      console.log(error);
      dispatch({
        type: EDIT_MEAL_ERROR,
        payload: `error: ${error}`
      });
      history.push(`/nutrition/${plan.id}`);
    });
};

// delete meal
export const deleteMeal = (plan, index, history) => async dispatch => {
  let firestore = firebase.firestore();
  let docRef = firestore.collection(NUTRITIONS).doc(plan.id);

  dispatch({ type: CURRENT_NUTRATION_LOADING_STATE });
  const meal = plan.meal_items[index];
  var meal_items = [...plan.meal_items];
  meal_items.splice(index, 1);
  const new_meals_count = meal_items.filter(m => m.type === "meal").length;
  const new_snacks_count = meal_items.length - new_meals_count;

  let newPlan = {
    ...plan,
    total_calories: roundNum(
      plan.total_calories -
        meal.ingredients_calories
    ),
    total_carbs: roundNum(
      plan.total_carbs -
        meal.ingredients_carbs
    ),
    total_fat: roundNum(
      plan.total_fat -
        meal.ingredients_fat
    ),
    total_protein: roundNum(
      plan.total_protein -
        meal.ingredients_protein
    ),
    meals_count: new_meals_count,
    snacks_count: new_snacks_count,
    meal_items: meal_items
  }
  docRef
    .set(
      {...newPlan},
      { merge: true }
    )
    .then(function() {
      dispatch({
        type: DELETE_MEAL_SUCCEEDED,
        payload: newPlan
      });
      history.push(`/nutrition/${plan.id}`);
    })
    .catch(function(error) {
      console.log(error);
      dispatch({
        type: DELETE_MEAL_ERROR,
        payload: `error: ${error}`
      });
      history.push(`/nutrition/${plan.id}`);
    });
};

// search for food
export const searchFood = (query, trainerUid) => async dispatch => {
  dispatch({
    type: LOADING_FOOD,
    payload: query
  });
  var search = firebase.functions().httpsCallable('apiNutritionixSearch');

  if (query)
    search({
      query: query,
      trainer_id: trainerUid
    })
      .then(function(res) {
        dispatch({
          type: SEARCH_FOOD_SUCCEEDED,
          payload: { search: res.data, query }
        });
      })
      .catch(function(error) {
        console.log(error);
        dispatch({
          type: SEARCH_FOOD_ERROR,
          payload: `error: ${error}`
        });
      });
  else
    dispatch({
      type: SEARCH_FOOD_SUCCEEDED,
      payload: { search: {}, query }
    });
};

export const getMeasures = (query, weight, calories, measure, quantity_size) => async dispatch => {
  dispatch({
    type: LOADING_MEASUREMENTS
  });
  var getMeasuresUnits = firebase.functions().httpsCallable('apiNutritionixGetMeasures');

  getMeasuresUnits({
    query: query,
    weight: weight,
    calories: calories,
    measure: measure,
    quantity_size: quantity_size
  })
    .then(function(result) {
      dispatch({
        type: GET_MEASUREMENTS_SUCCEEDED,
        payload: result.data
      });
    })
    .catch(function(error) {
      console.log(error);
      dispatch({
        type: GET_MEASUREMENTS_ERROR,
        payload: `error: ${error}`
      });
    });
};

// create food
export const createFood = food => async dispatch => {
  let firestore = firebase.firestore();
  var docRef = firestore.collection(FOOD);

  firebase.auth().onAuthStateChanged(user => {
    if (user) {
      food.created_at = new Date();
      food.trainer_id = user.uid;

      docRef
        .add(food)
        .then(function() {
          return dispatch({
            type: CREATE_FOOD_SUCCEEDED
          });
        })
        .catch(function(error) {
          console.log(error);
          dispatch({
            type: CREATE_FOOD_ERROR,
            payload: `error: ${error}`
          });
        });
    } else {
      dispatch({
        type: CREATE_FOOD_ERROR,
        payload: `error: ${USER_NOT_SIGNED_IN_ERROR_MSG}`
      });
    }
  });
};
